module.exports = __webpack_public_path__ + "img/hamburger.90fa8031.svg";